import * as z from "zod";

export const ReassignmentLineItemCoverageSchema = z.object({
  lineItemId: z.string(),
  name: z.string(),
  sku: z.string(),
  imageUrl: z.string().nullish(),
  needed: z.number(),
  onHand: z.number(),
});
export type ReassignmentLineItemCoverage = z.infer<
  typeof ReassignmentLineItemCoverageSchema
>;

export const ReassignmentLocationSchema = z.object({
  /** Destination location's external id — passed back to reassignAndMoveFulfillmentGroup. */
  externalLocationId: z.string(),
  name: z.string(),
  region: z.string().nullish(),
  /** All external-location mapping aliases for this location, across every selected group's source (e.g. ["RMR-EXT-LEH"]). */
  mappingAliases: z.array(z.string()),
  /** Per-item availability of this location for the order's line items. */
  items: z.array(ReassignmentLineItemCoverageSchema),
  ineligibleReason: z.string().nullish(),
});
export type ReassignmentLocation = z.infer<typeof ReassignmentLocationSchema>;

export const getReassignmentLocations = {
  name: "getReassignmentLocations" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()),
    fulfillmentServiceId: z.string(),
  }),
  output: z.object({ locations: z.array(ReassignmentLocationSchema) }),
};
